export default __webpack_public_path__ + "static/background_5-325df1f69aad723e41080aa0abb8dc24.png";